<div class="bg-gray shadow-sm rounded p-4">
  <div class="avatar-profile rounded-circle d-flex al-end sp-end">
    <div class="avatar-state bg-green rounded-circle">
    </div>
  </div>
  <div class="my-2 text-center">
    <span class="fw-bold fs-6">{{ rol == 1 ? user?.nombres : user?.nombre_completo}}</span>
  </div>
  <div class="mb-4 text-center">
    <span class="fw-regular fs-6 text-secondary">{{ rol == 1 ? 'Vendedor': getDateFormated(user?.registrado) }}</span>
  </div>
  <div class="d-flex al-center sp-center gap">
    <a [href]="'mailto:'+user?.correo">
      <img src="assets/svg/Icon_email.svg" width="36" class="pointer" alt="">
    </a>
    <a [href]="'https://calendar.google.com/calendar/render?action=TEMPLATE&add='+user?.correo" target="_blank">
      <img src="assets/svg/Icon_meet.svg" width="36" class="pointer" alt="">
    </a>
    <img src="assets/svg/Icon_editar_small.svg" width="36" class="pointer" (click)="editUser()" alt="">
    <img src="assets/svg/Icon_eliminar.svg" width="36" class="pointer" (click)="deleteUser()" alt="">
  </div>
</div>
<br>
<ng-container *ngIf=" rol == 3 ">
  <div class="mb-3">
    <span class="fs-6 fw-bold">Estado</span>
  </div>
  <div class="d-flex al-center sp-between">
    <div class="content-state d-flex al-center sp-center" [ngClass]="getColor(user?.cliente_estado)">
      <span class="text-white fs-6 fw-regular">{{ user?.cliente_estado }}</span>
    </div>
    <div>
      <span class="pointer underline text-blue fs-6" (click)="changeState()">Cambiar estado</span>
    </div>
  </div>
</ng-container>
<div class="my-4">
  <hr>
</div>
<br>
<app-detail-asesor-dashboard *ngIf="rol == 1" [dashboard]="user?.dashboard"></app-detail-asesor-dashboard>
<app-comments *ngIf="rol == 3" [comments]="user?.comentarios" [user]="user"></app-comments>